import React, { useState } from "react";
import cmsUtils from "../../utils/cmsUtils";
import { Item } from '../item';
import utils from "../../../utils";
import './style.scss';

export function AccordionParentPanel(props) {
    const item = props.item;
    const subItems = item.items || [];
    const cmsOption = props.cmsOption || {};

    const subItemsElts = subItems.map((subItem, index) =>
        <Item item={subItem} key={subItem.itemId} cmsOption={cmsOption}></Item>
    );

    const cssClass = utils.classNames(
        "cms_item",
        "accordionParentPanel",
        "contentPanel--",
        item.cssClass || item.anchorName || ""
    );

    console.log("item name:", subItemsElts);

    const firstAccordionTopic = subItemsElts.length > 0 ? subItemsElts[0].props.item.payloads[2].value : null;
    const [selectedAnchor, setSelectedAnchor] = useState(firstAccordionTopic);

    const handleClick = (accordionTopic) => {
        setSelectedAnchor(accordionTopic);
    };

    return (
        <section
            className={cssClass}
            data-cms-item-id={cmsOption.isCmsEdit && item.itemId}
            id={item.anchorName}
        >
            <div className="accordion-panel-lists">
                <ul>
                    {subItemsElts.map((subItem, index) => (
                        subItem.props.item.anchorName ? (
                            <React.Fragment key={index}>
                                <li
                                    key={index}
                                    onClick={() => handleClick(subItem.props.item.payloads[2].value)}
                                    className={`accordion-item ${selectedAnchor === subItem.props.item.payloads[2].value ? "selected" : ""}`}
                                >
                                    {subItem.props.item.payloads[2].value}
                                </li>
                            </React.Fragment>
                        ) : null
                    ))}
                </ul>
            </div>
            <div>
                {/* {subItemsElts} */}
                {subItemsElts.filter(subItem => subItem.props.item.payloads[2].value === selectedAnchor)}
            </div>
        </section>
    );
}